import React, { useState, useRef, useEffect, FC, RefObject } from 'react';
import { Animated, ScrollView } from 'react-native';

import { Element } from '@components/frame';
import { isPhoneNative, isWeb } from '@helpers';

import ThumbnailScroll from './components/ThumbnailScroll/ThumbnailScroll';
import ThumbnailMobileBottom from './components/ThumbnailMobileBottom';
import ThumbnailHeader from './components/ThumbnailHeader';
import { ColorFunction } from '@styles/colors/types';
import { ImageHandlingDisplayMode, GroupedImage } from '@v2/components/imageHandling/types/types.d';

export interface ThumbnailProps {
  C: ColorFunction;
  thumbnailScrollRef: RefObject<ScrollView>;
  groupedImages: Record<string, GroupedImage>;
  groupedImagesKeys: (keyof Record<string, GroupedImage>)[];
  setMode: (mode: ImageHandlingDisplayMode) => void;
  setSelectedIndex: (index: number) => void;
  setShowActions: (state: boolean) => void;
  onBackButtonPress?: () => void;
}

const Thumbnail: FC<ThumbnailProps> = (props) => {
  const { C, thumbnailScrollRef, groupedImages, groupedImagesKeys, setMode, setSelectedIndex, setShowActions, onBackButtonPress } = props;
  const [scrolled, setScrolled] = useState(false);
  const [headers, setHeaders] = useState({});
  const [oneTime, setOneTime] = useState(true);

  const fadeAnim = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    if (thumbnailScrollRef && thumbnailScrollRef.current && oneTime) {
      thumbnailScrollRef.current.scrollToEnd({ animated: false });
      setOneTime(false);
    }
  }, [groupedImagesKeys]);
  return (
    <Element
      {...{
        config: {
          position: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          },
          backgroundColor: C('Background/Dark/System', !isWeb),
        },
      }}
    >
      <ThumbnailHeader {...{ fadeAnim, scrolled, headers, C, setMode, onBackButtonPress }} />
      <ThumbnailScroll
        {...{
          groupedImages,
          groupedImagesKeys,
          scrollRef: thumbnailScrollRef,
          fadeAnim,
          setScrolled,
          scrolled,
          headers,
          setHeaders,
          setMode,
          setSelectedIndex,
          setShowActions,
          C,
        }}
      />
      {isPhoneNative && <ThumbnailMobileBottom C={C} setMode={setMode} />}
    </Element>
  );
};

export default Thumbnail;
